import { faPaperclip, faWrench } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Popover } from 'antd';
import "./_sues.css";
import SueItem from './_SueItem';
import "./_SuesTable.css";
import DynamicColumns from '../dynamicColumns/_DynamicColumns';
import { DynamicColumnsModel } from '../models/DynamicColumnsModel';

type Props = {
    data: any[];
    statuses?: any[];
    sortBy?: any;
    className?: string;
    config?: any;
    actions?: any;
    showOnlyRiders: boolean;
    onSelectSigning: (id: string) => void;
    fromClient?: boolean;
};


const SelectCollumnsPopOver = (props: any) => {
    const [optionsList, setOptionsList] = useState<any[]>([]);

    const buildOptionslist = () => {
        const collumnsNames = Object.keys(props.options);
        const rows: any[] = [];
        collumnsNames.forEach((collumn: string, key: number) => {
            rows.push({
                label: props.options[collumn].label,
                value: collumn,
                checked: !props.options[collumn].hidden
            });
        });
        setOptionsList(rows);

    }



    const onCheck = (optionValue: string) => {
        console.log('SelectCollumnsPopOver onCheck', optionValue);
        if (props.onCheck) {
            const opts = props.options;
            opts[optionValue].hidden = !opts[optionValue].hidden
            props.onCheck(opts)
        }
    }

    const onClose = () => {
        if (props.onHide) {
            props.onHide()
        }
    }

    // const onClearAll = () => {
    //     console.log('SelectCollumnsPopOver onClearAll');
    //     if (props.onCheck) {
    //         const opts = props.options;
    //         Object.keys(opts).forEach((key: string) => {
    //             opts[key].hidden = true;
    //         });
    //         props.onCheck(opts)
    //     }
    // }

    useEffect(() => {
        buildOptionslist();
    }, [props.options]);

    useEffect(() => {
        buildOptionslist();
    }, []);

    return (
        <div>
            {optionsList.map((option: any, index: number) => {
                return (
                    <div key={index} className='flex-start flex-reverse'>
                        <input type='checkbox' onChange={() => onCheck(option.value)} />
                        <div>
                            {option.label}
                        </div>
                    </div>
                )
            })}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>

                <a onClick={onClose}>Close</a>
                {/* <a onClick={onClearAll}>Clear All</a> */}
            </div>

        </div>
    )
}

const SuesTable = (props: Props) => {

    ////////////////////////////////Dynamic Columns//////////////////////////////////////
    const [dynamicColsList, setDynamicColsList] = useState<string[]>([]);
    const dynamicColumnsModel: DynamicColumnsModel = new DynamicColumnsModel();
    const buildDynamicColsList = async () => {
        await dynamicColumnsModel.DynamicColsGetUserDynamicColsNamesByModuleName("Sues").then((res: any) => {
            setDynamicColsList(res);
        });

    };

    useEffect(() => {
        const fetchData = async () => {
            await buildDynamicColsList();
        };

        fetchData();
    }, []);
    ////////////////////////////////Dynamic Columns//////////////////////////////////////



    const [itemsList, setItemsList] = useState<any[]>([]);
    const [showDropDown, setShowDropDown] = useState(false);
    const [additionalColumns, setAdditionalColumns] = useState<any>({

        internalNumber: {
            hidden: true,
            label: 'מס\' פנימי ',
        },
        carYear: {
            hidden: true,
            label: 'שנת ייצור ',
        },
        closingDate: {
            hidden: true,
            label: 'תאריך סגירה ',
        },
        agent: {
            hidden: true,
            label: 'סוכן ',
        },
        defendantCompany: {
            hidden: true,
            label: 'חברה נתבעת ',
        },
        user: {
            hidden: true,
            label: 'נוצר ע"י ',
        },
        requestedAmount: {
            hidden: true,
            label: 'סכום שנתבע ',
        },
        approvedAmount: {
            hidden: true,
            label: 'סכום שאושר ',
        },
        insuranceType: {
            hidden: true,
            label: 'סוג ביטוח ',
        },
        propertyDetails: {
            hidden: true,
            label: 'פרטי נכס ',
        },
        identifier: {
            hidden: true,
            label: 'ת.ז. לקוח ',
        }
    });
    const [sortBy, setSortBy] = useState<any | null>(null);


    const onSortChange = (property: string) => {
        if (props.actions.onSortChange) {
            props.actions.onSortChange(property)
        }
    }

    const onSelectSigning = (id: string) => {
        if (props.onSelectSigning) {
            console.log('props.onSelectSigning', props.onSelectSigning)

            props.onSelectSigning(id);
        }
    }

    const onAddTask = () => {
        // onAddTask
        if (props.actions && props.actions.onAddTask) {
            props.actions.onAddTask();
        }
    }

    const onAssignToHandler = (id: string) => {
        if (props.actions && props.actions.assignToHandler) {
            props.actions.assignToHandler(id);
        }
    }

    const addSigningComment = (commentData: any, signingId: string) => {
        if (props.actions && props.actions.addSigningComment) {
            props.actions.addSigningComment(commentData, signingId);
        }
    }


    const handleOpenChange = (newOpen: boolean) => {
        setShowDropDown(newOpen);
        console.log('onMenuOptionChange hide', newOpen)
    };
    const onMenuOptionChange = (options: any) => {
        console.log('onMenuOptionChange', options)
        setAdditionalColumns(options)
    }


    const editTask = (id: string) => {
        console.log('editTask');
        if (props.actions && props.actions.edit) {
            props.actions.edit(id)
        }
    }
    const onUpdate = (data: any) => {
        console.log('onUpdate');
        if (props.actions && props.actions.update) {
            props.actions.update(data)
        }
    }
    const sendEmail = (id: string) => {
        console.log('sendEmail');
        if (props.actions && props.actions.sendEmail) {
            props.actions.sendEmail(id)
        }
    }
    const sendWhatsApp = (id: string) => {
        console.log('sendWhatsApp');
        if (props.actions && props.actions.sendWhatsApp) {
            props.actions.sendWhatsApp(id)
        }
    }
    const setStatus = (id: string, status: string) => {
        console.log('setStatus');
        if (props.actions && props.actions.setStatus) {
            props.actions.setStatus(id, status);
        }
    }
    const deleteSigning = (id: string, status: string) => {
        console.log('deleteSigning');
        if (props.actions && props.actions.delete) {
            props.actions.delete(id);
        }
    }

    const onShowDocument = (url: string) => {
        if (props.actions && props.actions.onShowDocument) {
            props.actions.onShowDocument(url);
        }
    }

    useEffect(() => {
        const data = props.data ? props.data : [];
        setItemsList(data);
        console.log('data changed', props.data)
    }, [props.data]);

    useEffect(() => {
        setSortBy(props.sortBy);
        console.log('data sortBy changed', props.sortBy)
    }, [props.sortBy]);

    return (
        <div className={`content-table sues-content-table ${props.className ? props.className : ''}`}>
            <div className='content-header-sues'>
                <div className='status-icon'></div>
                <div className='client-name' onClick={() => onSortChange('sueNumber')}>
                    מס' תביעה
                    <div className={`icon sort ${props.sortBy && props.sortBy.property == 'sueNumber' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                        }`}></div>
                </div>
                <div className={`client-id ${!dynamicColsList || !dynamicColsList.includes("מס' פנימי")  ? 'hide' : ''}`}
                    onClick={() => onSortChange('internalNumber')}>
                    מס פנימי
                    <div className={`icon sort ${props.sortBy && props.sortBy.property == 'internalNumber' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                        }`}></div>
                </div>
                <div className='created'>
                    מס' פוליסה
                </div>
                <div className={`sue-policy-type`}>
                    סוג פוליסה
                    {/* <div className={`icon sort ${
                            props.sortBy && props.sortBy.property == 'alertDate' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                        }`}></div> */}
                </div>
                <div className={`alertDate ${!dynamicColsList || !dynamicColsList.includes("סוג ביטוח")  ? 'hide' : ''}`}>
                    סוג ביטוח
                </div>
                {props.fromClient ? <></> : (
                    <div className={`client-name`} onClick={() => onSortChange('Customer.FirstName')}>
                        שם לקוח
                        <div className={`icon sort ${props.sortBy && props.sortBy.property == 'Customer.FirstName' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                            }`}></div>
                    </div>
                )}
                <div className={`route-name ${!dynamicColsList || !dynamicColsList.includes("ת.ז. לקוח")  ? 'hide' : ''}`}>
                    ת.ז. לקוח
                </div>
                <div className={`insurance ${!dynamicColsList || !dynamicColsList.includes("פרטי נכס") ? 'hide' : ''}`}>
                    פרטי נכס
                </div>
                <div className={`insurance ${!dynamicColsList || !dynamicColsList.includes("שנת ייצור") ? 'hide' : ''}`}
                    onClick={() => onSortChange('carYear')}>
                    שנת ייצור
                    <div className={`icon sort ${props.sortBy && props.sortBy.property == 'carYear' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                        }`}></div>
                </div>
                <div className='sueDate' onClick={() => onSortChange('openingDate')}>
                    ת. פתיחה
                    <div className={`icon sort ${props.sortBy && props.sortBy.property == 'openingDate' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                        }`}></div>
                </div>
                <div className={`sueDate`} onClick={() => onSortChange('sueAccidentAndDamageInfo.accidentDateTime')}>
                    ת. מקרה
                    <div className={`icon sort ${props.sortBy && props.sortBy.property == 'sueAccidentAndDamageInfo.accidentDateTime' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                        }`}></div>
                </div>
                <div className={`license-id`} onClick={() => onSortChange('sueTypeLabel')}>
                    סוג תביעה
                    <div className={`icon sort ${props.sortBy && props.sortBy.property == 'sueTypeLabel' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                        }`}></div>
                </div>
                <div className={`alertDate`} onClick={() => onSortChange('activityStatusLabel')}>
                    מצב תביעה
                    <div className={`icon sort ${props.sortBy && props.sortBy.property == 'activityStatusLabel' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                        }`}></div>
                </div>
                <div className={`alertDate`} onClick={() => onSortChange('statusLabel')}>
                    סטטוס תביעה
                    <div className={`icon sort ${props.sortBy && props.sortBy.property == 'statusLabel' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                        }`}></div>
                </div>
                <div className={`creator`}>
                    מס' תביעה צ"ג
                </div>
                <div className={`alertDate client-name ${!dynamicColsList || !dynamicColsList.includes("תאריך סגירה") ? 'hide' : ''}`}
                    onClick={() => onSortChange('closingDate')}>
                    תאריך סגירה
                    <div className={`icon sort ${props.sortBy && props.sortBy.property == 'closingDate' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                        }`}></div>
                </div>
                <div className={`insurance-company`} onClick={() => onSortChange('insuranceCompany.name')}>
                    חברה מבטחת
                    <div className={`icon sort ${props.sortBy && props.sortBy.property == 'insuranceCompany.name' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                        }`}></div>
                </div>
                <div className={`creator ${!dynamicColsList || !dynamicColsList.includes("סוכן") ? 'hide' : ''}`}>
                    סוכן
                </div>
                <div className={`creator ${!dynamicColsList || !dynamicColsList.includes("חברה נתבעת") ? 'hide' : ''}`}>
                    חברה נתבעת
                </div>
                <div className={`creator`}>
                    מטפל בתביעה
                </div>
                <div className={`creator ${!dynamicColsList || !dynamicColsList.includes("נוצר ע\"י") ? 'hide' : ''}`}>
                    נוצר ע"י
                </div>
                <div className={`sue-price ${!dynamicColsList || !dynamicColsList.includes("סכום שנתבע") ? 'hide' : ''}`}
                    onClick={() => onSortChange('requestedAmount')}>
                    סכום שנתבע
                    <div className={`icon sort ${props.sortBy && props.sortBy.property == 'requestedAmount' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                        }`}></div>
                </div>
                <div className={`sue-price ${!dynamicColsList || !dynamicColsList.includes("סכום שאושר") ? 'hide' : ''}`}
                    onClick={() => onSortChange('approvedAmount')}>
                    סכום שאושר
                    <div className={`icon sort ${props.sortBy && props.sortBy.property == 'approvedAmount' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                        }`}></div>
                </div>
                {/* <div className={`status`}>
                    סטטוס 
                    </div>
                    <div className={`creator ${!additionalColumns || additionalColumns.agent.hidden ? 'hide' : ''}`}>
                    סוכן  
                    </div>
                    <div className={`creator ${!additionalColumns || additionalColumns.clientsGroups.hidden ? 'hide' : ''}`}>
                    קבוצת לקוחות   
                    </div> */}

                <div className="actions">
                    <Popover
                        placement="bottom"
                        content={
                            // <SelectCollumnsPopOver options={additionalColumns} onCheck={(opts: any)=>onMenuOptionChange(opts)} onHide={()=>handleOpenChange(false)} />

                            <DynamicColumns ModuleName="Sues" onChange={buildDynamicColsList}></DynamicColumns>

                        }
                        title="Title"
                        trigger="click"
                        open={showDropDown}
                        onOpenChange={handleOpenChange}
                    >
                        <div className='icon add black pointer'></div>
                    </Popover>
                </div>
            </div>
            <div className='content-data-table content-general-table-body content-table-body content-tasks-table-body'>
                {itemsList ? (<>
                    {itemsList.map((taskItem: any, index: number) => {
                        return (
                            <SueItem
                                details={taskItem}
                                statuses={props.statuses}
                                config={{
                                    additionalColumns: dynamicColsList,
                                    showOnlyRiders: props.showOnlyRiders,
                                    users: props.config.users,
                                }}
                                actions={{
                                    edit: editTask,
                                    update: onUpdate,
                                    sendEmail: sendEmail,
                                    sendWhatsApp: sendWhatsApp,
                                    setStatus: setStatus,
                                    delete: deleteSigning,
                                    onShowDocument: onShowDocument,
                                    onSelectSigning: (id: string) => onSelectSigning(id),
                                    onAddTask: onAddTask,
                                    onAssignToHandler: onAssignToHandler,
                                    addSigningComment: (commentData: any) => addSigningComment(commentData, taskItem.id),
                                    showAddTreatmentPopup: (type: number, customerId: string) => props.actions.showAddTreatmentPopup(type, customerId)
                                }}
                                key={index}
                                fromClient={props.fromClient} />
                        )
                    })}
                </>) : (<></>)}
            </div>
        </div>

    )
}
export default SuesTable;